import { render, staticRenderFns } from "./loginHandle.vue?vue&type=template&id=253692c8&"
import script from "./loginHandle.vue?vue&type=script&lang=js&"
export * from "./loginHandle.vue?vue&type=script&lang=js&"
import style0 from "./loginHandle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports